export * from './product-information'
